import React from 'react';
import { inject } from 'mobx-react';
import RectangularSmallCard from '../../../components/Card/RectangularSmallCard';
import { Row, Col } from 'react-bootstrap';

//components
import withLocalization from '~/hoc/withLocalization';
import applicationRouter from '~/hoc/applicationRouter'
import TimeBankMemberList from './TimeBankMemberList';
import { totalTimeFormat } from '../../../utils/dateFormat';
import ImportFromExcelModal from '../../../components/GenericModal/ImportFromExcelModal';

const TimeBank = ({ t, commonStore, userStore }) => {
    const dateTimeRules = commonStore?.config?.client?.data?.dateTimeRules || false;
    const timeBank = commonStore?.config?.client?.data?.basicRules?.timeBankSettings;
    const user_type = userStore?.currentUser?.user_type;
    const allowImportFromExcel = commonStore.config.client.data.basicRules?.allowImportFromExcel;

    return (
        <>
            <Row>
                <Col xs={6} md={6} className='d-flex'>
                    <span className='fw-600 custom-customer-header text-capitalize ps-1 pe-1'>{t('Time Bank')}</span>
                </Col>

                <Col xs={3} md={3}>
                    {(user_type === 'admin') && allowImportFromExcel && <div className='d-flex justify-content-end align-items-end'>
                        <div className='mt-4 pt-2'>
                            <ImportFromExcelModal
                                importEntityType={'timeBankBalance'}
                                entityName={`${t('Time Bank')} ${t('Balance')}`}
                                sampleFileName={'used_timebank_balance_import_sample_file.xlsx'}
                            />
                        </div>
                    </div>}
                </Col>
                {(user_type !== 'member') &&
                    <Col md={3} xs={9} className='d-flex justify-content-end'>
                        <RectangularSmallCard
                            title={t('Max Limit')}
                            customClassname="rectangle-card-timebank"
                            titleValue={totalTimeFormat(parseInt(timeBank?.maxHourLimitInCycle) * 60 + parseInt(timeBank?.maxMinuteLimitInCycle), dateTimeRules)}
                            percentage='100'
                            pathColor='red'
                            rotationStart='5'
                            strokeWidth='10'
                        />
                    </Col>
                }
            </Row>
            <TimeBankMemberList />
        </>
    )
}

export default inject('commonStore', 'userStore')(applicationRouter(withLocalization(TimeBank)));